import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

const customIcon = L.icon({
  iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
  iconSize: [22, 35], 
  iconAnchor: [12, 41],
  popupAnchor: [1, -34], 
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
  shadowSize: [20, 20], 
});

const MapComponent = ({coordinates, shipDetails}) => {
  // Provide fallback coordinates (Tokyo Bay, Japan) if coordinates are not available
  const defaultCoordinates = [35.6762, 139.6503];
  const mapCenter = coordinates && Array.isArray(coordinates) && coordinates.length === 2 
    ? coordinates 
    : defaultCoordinates;

  // Don't render the map if coordinates are completely invalid
  if (!coordinates || !Array.isArray(coordinates) || coordinates.length !== 2) {
    return (
      <div style={{ 
        height: "200px", 
        width: "100%", 
        display: "flex", 
        alignItems: "center", 
        justifyContent: "center",
        backgroundColor: "#F9FAFB",
        color: "#667085",
        fontSize: "14px"
      }}>
        Vessel tracking data not available
      </div>
    );
  }

  return (
    <MapContainer
      center={mapCenter}
      zoom={7}
      style={{ height: "200px", width: "100%" }}
      zoomControl={false} // Remove zoom buttons
    >
      {/* OpenStreetMap's own tiles: no key, fine for this light use under
          https://operations.osmfoundation.org/policies/tiles/ as long as the
          attribution stays. CARTO's basemaps now need an API key and served
          "API key required" watermarks. Same source as the marketing site's
          ship tracker. */}
      <TileLayer
        url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
        maxZoom={19}
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />
      <Marker position={mapCenter} icon={customIcon}>
        <Popup>
          Ship Name: {shipDetails?.name || 'Unknown'}<br/>
          {/* Auction lookups carry a zone; the dealer garage's cached positions do not. */}
          {shipDetails?.zone ? <>Zone: {shipDetails.zone}<br/></> : null}
        </Popup>
      </Marker>
    </MapContainer>
  );
};

export default MapComponent;
